'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const S3_URL_RE = /https:\/\/sparted-prod-([^.]+)\.s3(\.eu-west-1)?(\.amazonaws\.com)?(\.fr-par\.scw\.cloud)?(\/[^?]+)/;
const extractInfoFromUrl = (url) => {
    if (typeof url !== 'string') {
        return undefined;
    }
    const matchS3Url = url.match(S3_URL_RE);
    if (!matchS3Url) {
        return undefined;
    }
    const instanceId = matchS3Url[1];
    const path = matchS3Url[5];
    return { instanceId, path };
};

exports.extractInfoFromUrl = extractInfoFromUrl;
//# sourceMappingURL=extract-info-from-url.util.js.map
